module.exports = __webpack_public_path__ + "img/freelance3.7bc7ca17.png";